/* ==========================================================================
   Synterra Labs - Syntera Home interactions
   Mobile drawer, FAQ accordion, testimonial slider, footer accordion,
   live cart count.
   ========================================================================== */
(function () {
  'use strict';

  /* Guard: each syntera section includes this script, so it loads multiple
     times on the homepage. Without this, click handlers get duplicated and
     toggle states cancel each other out. */
  if (window.__synteraHomeReady) return;
  window.__synteraHomeReady = true;

  /* Mobile drawer */
  function initDrawer() {
    var openers = document.querySelectorAll('[data-syntera-drawer-open]');
    var drawers = document.querySelectorAll('[data-syntera-drawer]');
    if (!openers.length || !drawers.length) return;

    function setOpen(drawer, open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-syntera-drawer-open'));
        if (target) setOpen(target, true);
      });
    });

    drawers.forEach(function (drawer) {
      drawer.addEventListener('click', function (e) {
        if (
          e.target.closest('[data-syntera-drawer-close]') ||
          e.target.classList.contains('syntera-drawer__backdrop') ||
          e.target.classList.contains('syntera-mdrawer__overlay')
        ) {
          setOpen(drawer, false);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        drawers.forEach(function (d) {
          if (d.getAttribute('data-open') === 'true') setOpen(d, false);
        });
      }
    });
  }

  /* Mobile drawer submenu accordion (plus → min) */
  function initDrawerAccordion() {
    var toggles = document.querySelectorAll('[data-syntera-submenu-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var willOpen = !btn.classList.contains('is-open');
        btn.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (sub) { sub.hidden = !willOpen; }
      });
    });
  }

  /* FAQ accordion */
  function initFaq() {
    var items = document.querySelectorAll('[data-syntera-faq-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-syntera-faq-trigger]');
      var panel = item.querySelector('[data-syntera-faq-panel]');
      if (!trigger || !panel) return;

      // Initial: if open by default, set max-height
      if (item.getAttribute('data-open') === 'true') {
        requestAnimationFrame(function () { panel.style.maxHeight = panel.scrollHeight + 'px'; });
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        var parent = item.closest('[data-syntera-faq]');
        if (parent) {
          parent.querySelectorAll('[data-syntera-faq-item][data-open="true"]').forEach(function (sib) {
            if (sib !== item) {
              sib.setAttribute('data-open', 'false');
              var p = sib.querySelector('[data-syntera-faq-panel]');
              if (p) p.style.maxHeight = '0px';
              var t = sib.querySelector('[data-syntera-faq-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  /* Testimonial slider */
  function initSlider() {
    var sliders = document.querySelectorAll('[data-syntera-slider]');
    sliders.forEach(function (slider) {
      var track = slider.querySelector('[data-syntera-slider-track]');
      var dotsHost = slider.querySelector('[data-syntera-slider-dots]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var index = 0;

      function visibleCount() {
        var w = window.innerWidth;
        if (w < 600) return 1;
        if (w < 900) return 2;
        return 3;
      }
      function pageCount() {
        return Math.max(1, Math.ceil(slides.length / visibleCount()));
      }
      function update() {
        var v = visibleCount();
        var maxIdx = Math.max(0, pageCount() - 1);
        if (index > maxIdx) index = maxIdx;
        var slideW = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap || '0');
        var offset = index * v * (slideW + gap);
        track.style.transform = 'translateX(' + -offset + 'px)';
        renderDots();
      }
      function renderDots() {
        if (!dotsHost) return;
        var pages = pageCount();
        dotsHost.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'syntera-testimonials__dot';
          b.setAttribute('aria-label', 'Ga naar pagina ' + (i + 1));
          if (i === index) b.setAttribute('aria-current', 'true');
          (function (i) {
            b.addEventListener('click', function () { index = i; update(); });
          })(i);
          dotsHost.appendChild(b);
        }
      }

      // Touch swipe
      var startX = 0;
      var dragging = false;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        dragging = true;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) index = Math.min(index + 1, pageCount() - 1);
          else index = Math.max(0, index - 1);
          update();
        }
      });

      window.addEventListener('resize', update);
      // Defer first paint until images/layout settle
      requestAnimationFrame(update);
      window.addEventListener('load', update);
    });
  }

  /* Footer mobile accordion */
  function initFooterAccordion() {
    var cols = document.querySelectorAll('[data-syntera-footer-col]');
    cols.forEach(function (col) {
      var head = col.querySelector('h4');
      if (!head) return;
      head.addEventListener('click', function () {
        if (window.innerWidth > 540) return;
        col.setAttribute(
          'data-open',
          col.getAttribute('data-open') === 'true' ? 'false' : 'true'
        );
      });
    });
  }

  /* Cart drawer + cart count */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  var TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';

  function renderCartItem(item) {
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="syntera-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    var image = item.image
      ? '<img src="' + escapeHtml(item.image.replace(/(\.[a-z]+)$/i, '_160x$1')) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
      : '';
    return [
      '<div class="syntera-cart-item" data-cart-key="', escapeHtml(item.key), '">',
        '<a class="syntera-cart-item__image" href="', escapeHtml(item.url), '" aria-label="', escapeHtml(item.product_title), '">', image, '</a>',
        '<div class="syntera-cart-item__details">',
          '<h3 class="syntera-cart-item__title"><a href="', escapeHtml(item.url), '">', escapeHtml(item.product_title), '</a></h3>',
          variantTitle,
          '<div class="syntera-cart-item__qty">',
            '<button type="button" data-syntera-qty-down aria-label="Verminderen">−</button>',
            '<input type="number" min="0" value="', item.quantity, '" class="syntera-cart-item__qty-input" data-syntera-qty-input aria-label="Aantal">',
            '<button type="button" data-syntera-qty-up aria-label="Verhogen">+</button>',
          '</div>',
        '</div>',
        '<div class="syntera-cart-item__side">',
          '<button type="button" class="syntera-cart-item__remove" data-syntera-remove aria-label="Verwijderen">', TRASH_SVG, '</button>',
          '<p class="syntera-cart-item__price">', formatMoney(item.final_line_price || item.line_price), '</p>',
        '</div>',
      '</div>'
    ].join('');
  }

  function renderCart(cart) {
    if (!cart) return;
    // Update count badges
    document.querySelectorAll('[data-syntera-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      if (cart.item_count > 0) n.removeAttribute('hidden');
      else n.setAttribute('hidden', '');
    });

    var drawer = document.querySelector('[data-syntera-cart-drawer]');
    if (!drawer) return;

    var itemsHost = drawer.querySelector('[data-syntera-cart-items]');
    var emptyEl   = drawer.querySelector('[data-syntera-cart-empty]');
    var footerEl  = drawer.querySelector('[data-syntera-cart-footer]');
    var shippingEl = drawer.querySelector('[data-syntera-cart-shipping]');
    var subtotalEl = drawer.querySelector('[data-syntera-cart-subtotal]');
    var shippingCostEl = drawer.querySelector('[data-syntera-cart-shipping-cost]');
    var discountRowEl = drawer.querySelector('[data-syntera-cart-discount-row]');
    var discountEl    = drawer.querySelector('[data-syntera-cart-discount]');
    var originalEl    = drawer.querySelector('[data-syntera-cart-original]');

    if (cart.item_count === 0) {
      if (itemsHost) itemsHost.innerHTML = '';
      if (emptyEl)   emptyEl.style.display = 'flex';
      if (footerEl)  footerEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
      return;
    }

    if (emptyEl)   emptyEl.style.display = 'none';
    if (footerEl)  footerEl.style.display = '';
    if (shippingEl) shippingEl.style.display = '';

    if (itemsHost) itemsHost.innerHTML = cart.items.map(renderCartItem).join('');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Discount display (alleen tonen als Shopify Automatic Discount toegepast is)
    var discount = cart.total_discount || 0;
    if (discountRowEl) {
      if (discount > 0) discountRowEl.removeAttribute('hidden');
      else              discountRowEl.setAttribute('hidden', '');
    }
    if (discountEl && discount > 0) {
      discountEl.textContent = '−' + formatMoney(discount);
    }
    if (originalEl) {
      if (discount > 0 && cart.original_total_price) {
        originalEl.textContent = formatMoney(cart.original_total_price);
        originalEl.removeAttribute('hidden');
      } else {
        originalEl.setAttribute('hidden', '');
      }
    }

    // Verzending is altijd gratis. De banner ("Gratis verzending op alle bestellingen")
    // en de verzendregel zijn server-side statisch gerenderd; JS hoeft niets te herberekenen.
    // Voor de zekerheid houden we de verzendregel op "Gratis".
    if (shippingCostEl) shippingCostEl.textContent = 'Gratis';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) renderCart(cart);
        return cart;
      })
      .catch(function () { /* silent */ });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return cart;
    });
  }

  function setCartOpen(drawer, open) {
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-syntera-cart-drawer]');
    if (!drawer) return;
    var enabled = drawer.dataset.enabled !== 'false';

    // Open on cart icon click
    document.querySelectorAll('[data-syntera-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!enabled) return; // fall through to /cart link
        e.preventDefault();
        setCartOpen(drawer, true);
        refreshCart();
      });
    });

    // Close on backdrop / X / Escape
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-syntera-cart-close]') ||
          e.target.classList.contains('syntera-drawer__backdrop')) {
        setCartOpen(drawer, false);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        setCartOpen(drawer, false);
      }
    });

    // Quantity +/- and remove (event delegation)
    drawer.addEventListener('click', function (e) {
      var item = e.target.closest('[data-cart-key]');
      if (!item) return;
      var key = item.dataset.cartKey;
      var input = item.querySelector('[data-syntera-qty-input]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;

      if (e.target.closest('[data-syntera-qty-up]')) {
        changeLine(key, current + 1);
      } else if (e.target.closest('[data-syntera-qty-down]')) {
        changeLine(key, Math.max(0, current - 1));
      } else if (e.target.closest('[data-syntera-remove]')) {
        changeLine(key, 0);
      }
    });

    // Quantity input change
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-syntera-qty-input]')) return;
      var item = e.target.closest('[data-cart-key]');
      if (!item) return;
      changeLine(item.dataset.cartKey, parseInt(e.target.value, 10) || 0);
    });
  }

  /* Globale add-to-cart interceptor — vangt elk form dat naar /cart/add post,
     doet fetch ipv navigatie, en opent de cart drawer. Werkt voor product
     hero ATC, collections quick-add, homepage cards. */
  function openCartDrawerForced() {
    // Drawer HTML gebruikt data-syntera-cart-drawer (enkele r) — section heet syntera-cart-drawer
    var drawer = document.querySelector('[data-syntera-cart-drawer], [data-synterra-cart-drawer]');
    if (!drawer) {
      console.warn('[Synterra] Cart drawer not found in DOM');
      return false;
    }
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    console.log('[Synterra] Cart drawer opened');
    return true;
  }

  function applyBundleDiscount() {
    var code = window.SynterraBundleDiscount;
    if (!code) return Promise.resolve();
    // /discount/CODE applies the code to the current session. Failures (code
    // niet eligible) are stil — Shopify negeert het en cart valt terug op base prijs.
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    })
    .then(function () { console.log('[Synterra] Bundle discount code applied:', code); })
    .catch(function (e) { console.warn('[Synterra] Discount apply failed (mogelijk niet eligible):', e); });
  }

  function handleAddToCart(form) {
    var submitBtn = form.querySelector('button[type="submit"], [data-synterra-atc]');
    if (submitBtn) submitBtn.disabled = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data.status && data.status >= 400) {
        if (submitBtn) submitBtn.disabled = false;
        console.warn('[Synterra] Add to cart error:', data);
        return;
      }
      console.log('[Synterra] Added to cart:', data);

      // Drawer + button re-enable METEEN — geen wachttijd op discount of refresh
      openCartDrawerForced();
      if (submitBtn) submitBtn.disabled = false;

      // Cart inhoud verversen in parallel — toont het nieuwe item direct
      refreshCart();

      // Bundle discount fire-and-forget; bij succes een tweede refresh voor de prijsupdate
      applyBundleDiscount().then(function () {
        refreshCart();
      });
    })
    .catch(function (err) {
      if (submitBtn) submitBtn.disabled = false;
      console.error('[Synterra] Add to cart failed:', err);
    });
  }

  function initGlobalAddToCart() {
    // 1) Form submit interceptor (vangt enter-toets + submit buttons)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      handleAddToCart(form);
    }, true); // useCapture = true: vangt event eerder, voorkomt page navigation

    // 2) Click interceptor als extra vangnet (bv. button heeft formaction)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-synterra-atc]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      handleAddToCart(form);
    }, true);
  }

  /* Premium products slider (mobile arrows + swipe) */
  function initProductsSlider() {
    document.querySelectorAll('[data-synterra-products-slider]').forEach(function (root) {
      var track = root.querySelector('[data-synterra-products-track]');
      var prev  = root.querySelector('[data-synterra-products-prev]');
      var next  = root.querySelector('[data-synterra-products-next]');
      if (!track || !prev || !next) return;

      function slides() { return track.querySelectorAll(':scope > *'); }

      // Index van de slide die het dichtst tegen de linkerrand van de track staat
      function currentIndex() {
        var items = slides();
        if (!items.length) return 0;
        var trackLeft = track.getBoundingClientRect().left;
        var best = 0, bestDist = Infinity;
        items.forEach(function (el, i) {
          var d = Math.abs(el.getBoundingClientRect().left - trackLeft);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      // Ga naar slide i met wrap-around (loop): -1 => laatste, n => eerste
      function goTo(i) {
        var items = slides();
        if (!items.length) return;
        var n = items.length;
        var idx = ((i % n) + n) % n;
        var target = items[idx];
        var left = target.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        track.scrollTo({ left: left, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      next.addEventListener('click', function () { goTo(currentIndex() + 1); });

      // Loop-slider: pijlen blijven altijd actief (geen disabled-state)
      prev.disabled = false;
      next.disabled = false;
    });
  }

  function boot() {
    initDrawer();
    initDrawerAccordion();
    initFaq();
    initSlider();
    initFooterAccordion();
    initCartDrawer();
    initGlobalAddToCart();
    initProductsSlider();
    refreshCart();
    document.addEventListener('cart:refresh', refreshCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
